// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsPage_root__VZC7_","integrations":"IntegrationsPage_integrations__OiVpC","footer":"IntegrationsPage_footer__ONShu","note":"IntegrationsPage_note__HOVCx"};